package co.uk.sacursoftware.ssinventory.ui

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import co.uk.sacursoftware.ssinventory.util.UserRole

@Composable
fun WebPinDialog(
    onRoleSelected: (UserRole) -> Unit,
    onDismiss: () -> Unit
) {
    var pinInput by remember { mutableStateOf("") }
    var errorMessage by remember { mutableStateOf<String?>(null) }

    fun submitPin() {
        when (pinInput.trim()) {
            "230925" -> onRoleSelected(UserRole.ADMIN)
            "112233" -> onRoleSelected(UserRole.EDITOR)
            else -> errorMessage = "Incorrect PIN"
        }
    }

    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text("Unlock staff mode") },
        text = {
            Column {
                Text(
                    "Enter PIN for Admin or Editor. Leave as Shop if you dismiss.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant
                )
                Spacer(modifier = Modifier.height(16.dp))
                OutlinedTextField(
                    value = pinInput,
                    onValueChange = {
                        pinInput = it.filter { ch -> ch.isDigit() }.take(8)
                        errorMessage = null
                    },
                    label = { Text("PIN") },
                    singleLine = true,
                    visualTransformation = PasswordVisualTransformation(),
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.NumberPassword),
                    textStyle = MaterialTheme.typography.bodyLarge.copy(fontSize = 16.sp),
                    modifier = Modifier.fillMaxWidth(),
                    shape = MaterialTheme.shapes.small,
                    isError = errorMessage != null
                )
                if (errorMessage != null) {
                    Spacer(modifier = Modifier.height(8.dp))
                    Text(errorMessage!!, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
                }
            }
        },
        confirmButton = {
            Button(onClick = ::submitPin, shape = MaterialTheme.shapes.medium) {
                Text("Unlock")
            }
        },
        dismissButton = {
            TextButton(onClick = { onRoleSelected(UserRole.SHOP) }) {
                Text("Shop")
            }
        },
        shape = MaterialTheme.shapes.large
    )
}
